import React from 'react'
import StandardLayout from '@@layouts/StandardLayout'
import { ExternalLink } from '@@components/common'
import SEO from '@@components/seo'

import styles from './Attributions.module.scss'

export const Attributions = () => (
  <StandardLayout>
    <SEO title="Attributions" />

    <ul className={styles.attributions}>
      <li>Icons - <ExternalLink to="https://www.flaticon.com/" title="Flaticon" linkText="Flat Icons" /></li>
      <li>Site Logo - <ExternalLink to="https://fairpixels.co" linkText="Fair Pixels" /></li>
    </ul>
  </StandardLayout>
)
